import { render, staticRenderFns } from "./ShowForm.vue?vue&type=template&id=aa679db0&scoped=true&"
import script from "./ShowForm.vue?vue&type=script&lang=js&"
export * from "./ShowForm.vue?vue&type=script&lang=js&"
import style0 from "./ShowForm.vue?vue&type=style&index=0&id=aa679db0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa679db0",
  null
  
)

export default component.exports